import { Component, OnInit,Input } from '@angular/core';
import { WalletService } from '../../Services/wallet.service';


@Component({
  selector: 'app-wallet-topup',
  templateUrl: './wallet-topup.component.html',
  styleUrls: ['./wallet-topup.component.css']
})
export class WalletTopupComponent implements OnInit {

  @Input()walletAmount: any;
  @Input()wallettext: any;
  amountToaddinwallet=0;
  constructor(public walletService:WalletService) { }

  ngOnInit(): void {
// console.log(this.walletAmount,this.wallettext)
  }

  beforepay(){
// console.log("Before Pay")
    this.walletService.amountToaddinwallet=this.amountToaddinwallet;
   this.walletService.payEvent();
   
  }
  ngOnDestroy(){
// console.log("Destroyed!!")
  }

  
}
